import { Send } from 'lucide-react'

interface ChatHeaderProps {
  title: string
}

export function ChatHeader({ title }: ChatHeaderProps) {
  return (
    <div className="border-b bg-card h-16 flex items-center px-6 mb-6">
      <div className="flex items-center gap-3">
        <div className="p-2 rounded-lg bg-blue-50/50 dark:bg-blue-950/20 flex-shrink-0">
          <Send className="h-4 w-4 text-blue-600 dark:text-blue-400" />
        </div>
        <h1 className="text-lg font-semibold text-foreground">
          {title || 'Contextual Chat'}
        </h1>
      </div>
    </div>
  )
} 